import PropTypes from 'prop-types';
import Markdown from 'components/Markdown';
import { Alert } from '@integration/alexandria-ui';

const GenericAlert = ({ message, title, type }) => {
  return (
    <div data-testid="alert-container">
      <Alert
        shouldShowButton={false}
        type={type}
        title={title}
        text={<Markdown text={message} />}
      />
    </div>
  );
};

GenericAlert.propTypes = {
  id: PropTypes.string,
  message: PropTypes.string,
};

GenericAlert.defaultProps = {
  id: '',
  message: '',
};

export default GenericAlert;
